import React, { useState, useEffect } from 'react';
import { Carousel } from "antd";
import { imageUrl, zeusApp } from '../request/index';
import { useCustomData } from '../pages/context/indexCustomDataContext';

const PomeloSwiper: React.FC = () => {
    const { getValue } = useCustomData();
    const homeBanner = getValue('homeBanner'); // "id1,id2,id3"

    const [imageIds, setImageIds] = useState<string[]>([]);

    useEffect(() => {
        if (homeBanner) {
            const ids = homeBanner.split(',').map((id: string) => id.trim());
            setImageIds(ids);
        }
    }, [homeBanner]);

    const contentStyle: React.CSSProperties = {
        margin: 0,
        height: '603px',
        color: '#fff',
        lineHeight: '603px', // 居中显示
        textAlign: 'center',
        background: '#0e08f9',
    };

    return (
        <div className="pomelo-swiper">
            <Carousel autoplay>
                {imageIds.map((id, index) => (
                    <div key={index}>
                        <div style={contentStyle}>
                            <img
                                src={`${imageUrl}${id}?zeus-app=${zeusApp}`}
                                alt={`slide-${index}`}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default PomeloSwiper;
